<script lang="ts">
    import { type TagNodeObject } from '$lib/bbcode/parser/types';
    import BBCodeTree from '$components/BBCode/BBCodeTree.svelte';
    import * as z from 'zod';
    import { parseAttrs } from '$lib/bbcode/parseBBcode';
    import { getContainer } from '$components/Context/ContainerContext';
    import { cx } from '$lib/utils/cx';

    export let node: TagNodeObject;
    $: attrs = parseAttrs(
        z.object({
            class: z.string().nullish(),
            href: z.string().nullish(),
            hrefCode: z.string().nullish(),
            target: z.string().nullish(),
            obfuscate: z.string().nullish(),
        }),
        node.attrs,
    );

    const { urlHelper } = getContainer();

    $: attrClass = attrs.class ?? null;
    $: attrHrefCode = attrs.hrefCode ?? null;
    $: attrHref = attrs.href ?? attrs.__default ?? '';
    $: attrTarget = attrs.target ?? null;
    $: attrObfuscate = attrs.obfuscate ?? 'false';
    $: obfuscate = attrObfuscate === 'true' || attrObfuscate === '1';

    function getHref(href: string, hrefCode: string | null): string {
        if (href !== '') {
            return href;
        } else if (hrefCode === 'politique-confidentialite') {
            return urlHelper().withAbsoluteUrl(true).politiqueConfidentialite();
        } else {
            return '';
        }
    }

    function onButtonClick(event: MouseEvent) {
        const href = getHref(attrHref, attrHrefCode);
        if (attrTarget === '_blank' || event.metaKey || event.ctrlKey) {
            window.open(href);
        } else {
            window.location.assign(href);
        }
    }
</script>

{#if obfuscate}
    <button
        class={cx('btn-reset btn-link', attrClass ?? '')}
        on:click|preventDefault={onButtonClick}
    >
        <BBCodeTree nodes={node.content} let:slotName let:slotContent>
            <slot {slotName} {slotContent} />
        </BBCodeTree>
    </button>
{:else}
    <a
        class={attrClass}
        href={getHref(attrHref, attrHrefCode)}
        target={attrs.target}
        data-sveltekit-reload={true}
    >
        <BBCodeTree nodes={node.content} let:slotName let:slotContent>
            <slot {slotName} {slotContent} />
        </BBCodeTree>
    </a>
{/if}
